<form [formGroup]='formGroup' class='mb-4'>

  <div *ngIf='!domain && domainLabel' class='w-100 mb-3'>
    <label class='text-secondary form-label' for='domain'>{{ domainLabel }}</label>
    <input autocomplete='off'
           class='form-control form-control-sm'
           formControlName='domain'
           id='domain'
           type='text'>
  </div>

  <div *ngIf='emailLabel' class='w-100 mb-3'>
    <label class='text-secondary form-label' for='email'>{{ emailLabel }}</label>
    <input autocomplete='off'
           class='form-control form-control-sm'
           formControlName='email'
           id='email'
           type='email'>
  </div>

</form>

<pt-sign-actions
  (onCancel)='clickCancel.emit()'
  (onConfirm)='confirm()'
  [cancelLabel]='cancelLabel'
  [confirmLabel]='confirmLabel'
  [enabledConfirm]='formGroup.valid && !loading'
  [showCancel]='true'
  [showConfirm]='true'>
</pt-sign-actions>
